// Image Upscaler 图片放大功能翻译

export const imageUpscaler = {
    // Page title and subtitle
    title: 'AI Image Upscaler',
    subtitle: 'Enhance your images with AI-powered upscaling technology',
    
    // Upload section
    details: 'Upload Details',
    uploadText: 'Upload an image to get started',
    uploadFormats: 'Supports JPG, PNG, WebP formats, max 10MB',
    uploadImageFirst: 'Please upload an image first',
    
    // Settings
    factor: 'Upscale Factor',
    faceEnhancement: 'Face Enhancement',
    enhanceTypes: 'Enhancement Types',
    
    // Enhancement type options
    denoise: 'Denoise',
    face_enhance: 'Face Enhancement',
    sharpen: 'Sharpen',
    color_enhance: 'Color Enhancement',
    detail_enhance: 'Detail Enhancement',
    
    // Actions
    enhance: 'Enhance Image',
    processing: 'Processing',
    downloadButton: 'Download Enhanced Image',
    
    // Preview section
    preview: 'Preview',
    processingOverlay: 'Processing your image...',
    noImageUploaded: 'No image uploaded',
    resultTitle: 'Enhanced Result',
    
    // Features section
    featuresTitle: 'Powerful Features',
    feature1Title: 'AI-Powered Enhancement',
    feature1Desc: 'Advanced AI algorithms enhance image quality while preserving details.',
    feature2Title: 'Multiple Scale Factors',
    feature2Desc: 'Choose from 2x, 4x, or 8x upscaling to meet your specific needs.',
    feature3Title: 'Face Enhancement',
    feature3Desc: 'Specialized face enhancement technology for portrait photos.',
    feature4Title: 'High-Quality Output',
    feature4Desc: 'Professional-grade results suitable for print and digital use.',
    
    // How to use section
    howToUseTitle: 'How to Use',
    step1Title: 'Upload Image',
    step1Desc: 'Select and upload your image file (JPG, PNG, or WebP format).',
    step2Title: 'Choose Settings',
    step2Desc: 'Select upscale factor and enable face enhancement if needed.',
    step3Title: 'Download Result',
    step3Desc: 'Process your image and download the enhanced version.',
    
    // FAQ section
    faqTitle: 'Frequently Asked Questions',
    faq1: 'What image formats are supported? We support JPG, PNG, and WebP formats.',
    faq2: 'What is the maximum file size? The maximum file size is 10MB per image.',
    faq3: 'How long does processing take? Processing typically takes 30-60 seconds depending on image size and settings.',
    
    // Footer
    footerCopyright: '© 2025 Catoo. All rights reserved.',
    
    // Error messages
    loginExpired: 'Login session expired. Please log in again.',
    imageUpscaleFailed: 'Image upscaling failed. Please try again.',
    networkError: 'Network error. Please check your connection and try again.',
    queryStatusFailed: 'Failed to query processing status.',
    processingTimeout: 'Processing timeout. Please try again.',
    downloadFailed: 'Download failed. Please try again.',
    
    // Success messages
    imageUpscaleComplete: 'Image upscaling completed successfully!'
  };
